module.exports = __webpack_public_path__ + "lato-light-italic-b55e385f24f0f9f724dac935fe292ecf.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-light-italic/lato-light-italic.woff
// module id = 1045
// module chunks = 0